<template>
    <div id="app">
        <main role="main" class="main-cont">
            <div class="row m-0 main-section">
                <div class="col-sm-12 right-section homebody">
                    <div class="row" style="margin-top:30px;">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8 card bg-light">
                            <h1 class="mb-4 appName">Bank and ERP Reconciliation</h1>
                            <div class="panelDiv">
                                <div v-if="loading" class="spinner__icon spinner__icon--xxlarge spinner_position">
                                </div>
                                <div class="col-sm-12">
                                    <div class="col-sm-6 col-md-6">
                                        <h2 class="mb-3 subHeader">Select Bank Name</h2>
                                    </div>
                                    <div class="col-sm-7 col-md-7">
                                        <select class="form-control selectarrow"
                                                aria-label="Select bank name"
                                                title="Bank Name"
                                                v-model="selectedBank"
                                                v-on:change="handleclientMapping()"
                                                v-validate="'required'"
                                                name="bankName"
                                                :class="{'is-invalid':errors.has('bankName')}">
                                            <option value selected disabled>Please select Bank Name</option>
                                            <option v-for="bnk in bankarrayresult"
                                                    :value="bnk.bankname"
                                                    :key="bnk.id">
                                                {{ bnk.bankname }}
                                            </option>
                                        </select>
                                        <span v-show="errors.has('bankName')"
                                              class="text-danger">Please select the Bank Name</span>
                                    </div>

                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="col-sm-6 col-md-6">
                                        <h2 class="mb-3 subHeader">Select Client Name</h2>
                                    </div>
                                    <div class="col-sm-7 col-md-7">
                                        <select v-model="selectedClient"
                                                aria-label="Select client name"
                                                title="Client Name"
                                                class="form-control selectarrow"
                                                v-validate="'required'"
                                                name="clientName"
                                                :class="{'is-invalid':errors.has('clientName')}">
                                            <option value selected disabled>Please select Client Name</option>
                                            <option v-for="clt in clientarrayresult"
                                                    :value="clt.clientname"
                                                    :key="clt.id">
                                                {{ clt.clientname }}
                                            </option>
                                        </select>
                                        <span v-show="errors.has('clientName')"
                                              class="text-danger">Please select the Client Name</span>
                                    </div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div style="width: 106%;">
                                        <div class="col-sm-7 col-md-7 col-7 row">
                                            <div class="col-sm-6 col-md-5 col-5">
                                                <h2 class="mb-3 subHeader">Start Date</h2>
                                                <input type="date"
                                                       v-validate="'required'"
                                                       class="form-control border input-control-border"
                                                       id="startdate"
                                                       v-model="startdate"
                                                       title="Start Date Picker"
                                                       placeholder="Enter Start Date"
                                                       name="startdate"
                                                       aria-label="User Cursor to navigate, enter to select and esc to close"
                                                       style="border-color: gray !important; background-color: #e7e7ea;"
                                                       :class="{'is-invalid':!isDateValid || errors.has('startdate')}" />
                                            </div>
                                            <div class="col-sm1-1 col-md-2 col-2"></div>
                                            <!-- style="padding-left:0px;" -->
                                            <div class="col-sm-6 col-md-5 col-5">
                                                <h2 class="mb-3 subHeader">End Date</h2>
                                                <input type="date"
                                                       v-validate="'required'"
                                                       class="form-control border input-control-border"
                                                       id="enddate"
                                                       v-model="enddate"
                                                       title="End   Date Picker"
                                                       placeholder="Enter End Date"
                                                       aria-label="User Cursor to navigate, enter to select and esc to close"
                                                       name="enddate"
                                                       style="border-color: gray !important;  background-color: #e7e7ea;"
                                                       :class="{'is-invalid':!isDateValid || errors.has('enddate')}" />
                                            </div>
                                        </div>
                                        <div class="col-sm-7 col-md-7 col-7 row">
                                            <div class="col-sm-6 col-md-5 col-5">
                                                <span v-show="errors.has('startdate') && errors.has('enddate')"
                                                      class="text-danger">Date range is mandatory</span>
                                                <span v-show="errors.has('startdate') && !errors.has('enddate')"
                                                      class="text-danger">Please select the start date</span>
                                                <span v-show="errors.has('enddate') && !errors.has('startdate')"
                                                      class="text-danger">Please select the end date</span>
                                                <span v-show="!isDateValid"
                                                      class="text-danger">End date must be greater than start date</span>
                                            </div>
                                        </div>

                                        <!-- <div class="col-sm-7 col-md-7 row">
                                            <div class="col-sm-5 col-md-5" style="padding-right:0px;">
                                                <input type="date"
                                                       v-validate="'required'"
                                                       class="form-control border input-control-border"
                                                       id="startdate"
                                                       v-model="startdate"
                                                       placeholder="Enter Start Date"
                                                       name="startdate"
                                                       style="border-color: gray !important; background-color: #e7e7ea;"
                                                       :class="{'is-invalid':!isDateValid || errors.has('startdate')}" />
                                            </div>
                                            <div class="col-sm-2 col-md-2"></div>
                                            <div class="col-sm-5 col-md-5" style="padding-left:0px;">
                                                <input type="date"
                                                       v-validate="'required'"
                                                       class="form-control border input-control-border"
                                                       id="enddate"
                                                       v-model="enddate"
                                                       placeholder="Enter End Date"
                                                       name="enddate"
                                                       style="border-color: gray !important;  background-color: #e7e7ea;"
                                                       :class="{'is-invalid':!isDateValid || errors.has('enddate')}" />
                                            </div>
                                        </div> -->
                                        <!--<div class="col-sm-7 col-md-7 row">-->
                                        <!--</div>-->
                                    </div>
                                </div>
                            </div>
                            <div class="panelDiv">
                                <div>
                                    <div class="col-sm-9 col-md-7 dp-inline-fx"></div>
                                    <h2 class="mb-3 subHeader">Bank Statement</h2>
                                    <div class="row col-sm-12 col-md-12 col-xs-12 col-12 mb-4">
                                        <div class="col-sm-9 col-md-7">
                                            <label>Select Bank Statement (.xlsx)</label>
                                            <div class="row">
                                                <div class="file-upload col-sm-12 col-md-12 col-xs-12 col-12">
                                                    <div class="file-select" :class="{'is-invalid':errors.has('chooseBankStatement')}">
                                                        <div class="file-select-name col-sm-8 col-md-8 col-xs-8 col-8" id="noFile">{{BankUploadFile}}</div>
                                                        <input class="col-sm-12 col-md-12 col-12"
                                                               type="file"
                                                               title="Choose Bank statement file"
                                                               aria-label="Click browse to select bank statement file"
                                                               name="chooseBankStatement"
                                                               id="bankStatementFile"
                                                               ref="bankStatementFile"
                                                               v-validate="`required|size:${fileSize}`"
                                                               v-on:change="handleBankStatement()"
                                                               accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                                                        <button class="file-select-button col-sm-4 col-md-4 col-xs-4 col-4" aria-label="Browse to select bank statement file" title="Browse button" id="fileName">Browse</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <span v-show="errors.has('chooseBankStatement')"
                                                  class="text-danger">Please select a valid Bank Statement</span>
                                        </div>
                                        <div class="col-sm-3 col-md-5"></div>
                                    </div>
                                    <div class="row col-sm-12">
                                        <div class="col-sm-9 col-md-7 dp-inline-fx">
                                            <div class="col-sm-6 pl-0">
                                                <div class="mt-2 new-form">
                                                    <div class="floating-label d-flex flex-column flex-md-row">
                                                        <input v-model="colstartbs"
                                                               title="Start Column for bank statement"
                                                               aria-label="Start column value, use cursor up and down to increase or decrease"
                                                               class="floating-input"
                                                               type="number"
                                                               placeholder=" "
                                                               name="colstartbs"
                                                               v-validate="'required|colParameter'"
                                                               v-on:keypress="isNumber($event)" />
                                                        <span class="highlight"></span>
                                                        <label>Start Column</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 pr-0">
                                                <div class="mt-2 new-form">
                                                    <div class="floating-label d-flex flex-column flex-md-row">
                                                        <input v-model="colendbs"
                                                               class="floating-input"
                                                               title="End Column for bank statement"
                                                               aria-label="End column value, use cursor up and down to increase or decrease"
                                                               type="number"
                                                               placeholder=" "
                                                               name="colendbs"
                                                               v-validate="'required|colParameter'"
                                                               v-on:keypress="isNumber($event)" />
                                                        <span class="highlight"></span>
                                                        <label>End Column</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row col-sm-12">
                                        <div class="col-sm-9 col-md-7 dp-inline-fx">
                                            <div class="col-sm-6 pl-0">
                                                <div class="mt-2 new-form">
                                                    <div class="floating-label d-flex flex-column flex-md-row">
                                                        <input v-model="rowstartbs"
                                                               class="floating-input"
                                                               title="Start row for bank statement"
                                                               aria-label="Start row value, use cursor up and down to increase or decrease"
                                                               type="number"
                                                               placeholder=" "
                                                               name="rowstartbs"
                                                               v-validate="'required|rowParameter'"
                                                               v-on:keypress="isNumber($event)" />
                                                        <span class="highlight"></span>
                                                        <label>Start Row</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 pr-0">
                                                <div class="mt-2 new-form">
                                                    <div class="floating-label d-flex flex-column flex-md-row">
                                                        <input v-model="rowendbs"
                                                               title="End row for bank statement"
                                                               aria-label="End row value, use cursor up and down to increase or decrease"
                                                               class="floating-input"
                                                               type="number"
                                                               placeholder=" "
                                                               name="rowendbs"
                                                               v-validate="'required|rowParameter'"
                                                               v-on:keypress="isNumber($event)" />
                                                        <span class="highlight"></span>
                                                        <label>End Row</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row col-sm-12">
                                        <div class="col-sm-9 col-md-7">
                                            <span v-show="errors.has('colstartbs'&&'colendbs'&&'rowstartbs'&&'rowendbs')"
                                                  class="text-danger">Please enter the mandatory parameters</span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <div class="col-sm-12 p-0 m-0 row b-line mb-4 mt-3"></div>
                                        <h2 class="mb-3 subHeader">ERP Statement</h2>
                                        <div class="row col-sm-12 mb-4">
                                            <div class="col-sm-9 col-md-7">
                                                <label>Select TOTVS Statement (.xlsx)</label>
                                                <div class="row">
                                                    <div class="file-upload col-sm-12 col-md-12 col-12">
                                                        <div class="file-select" :class="{'is-invalid':errors.has('chooseTotvStatement')}">
                                                            <div class="file-select-name col-sm-8 col-md-8 col-8" id="noFile">{{TOTVUploadFile}}</div>
                                                            <input lass="col-sm-12 col-md-12 col-12"
                                                                   type="file"
                                                                   name="chooseTotvStatement"
                                                                   id="TOTVStatementFile"
                                                                   ref="TOTVStatementFile"
                                                                   title="Choose Bank statement file"
                                                                   aria-label="Click browse to select bank statement file"
                                                                   v-validate="`required|size:${fileSize}`"
                                                                   v-on:change="handleTOTVSStatement()"
                                                                   :class="{'is-invalid':errors.has('chooseTotvStatement')}"
                                                                   accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                                                            <button class="file-select-button col-sm-4 col-md-4 col-4" aria-label="Browse to select TOTV statement file" title="Browse button" id="fileName">Browse</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span v-show="errors.has('chooseTotvStatement')"
                                                      class="text-danger">Please select a valid TOTVS Statement</span>
                                            </div>
                                            <div class="col-sm-3 col-md-5"></div>
                                        </div>
                                        <div class="row col-sm-12">
                                            <div class="col-sm-9 col-md-7 dp-inline-fx" name="bankRow">
                                                <div class="col-sm-6 pl-0">
                                                    <div class="mt-2 new-form">
                                                        <div class="floating-label d-flex flex-column flex-md-row">
                                                            <input v-model="colstartvs"
                                                                   title="Start Column for TOTVS statement"
                                                                   aria-label="Start column value, use cursor up and down to increase or decrease"
                                                                   name="colstartvs"
                                                                   class="floating-input"
                                                                   type="number"
                                                                   placeholder=" "
                                                                   v-validate="'required|colParameter'"
                                                                   v-on:keypress="isNumber($event)" />
                                                            <span class="highlight"></span>
                                                            <label>Start Column</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6 pr-0">
                                                    <div class="mt-2 new-form">
                                                        <div class="floating-label d-flex flex-column flex-md-row">
                                                            <input v-model="colendvs"
                                                                   name="colendvs"
                                                                   title="End Column for TOTVS statement"
                                                                   aria-label="End column value, use cursor up and down to increase or decrease"
                                                                   class="floating-input"
                                                                   type="number"
                                                                   placeholder=" "
                                                                   v-validate="'required|colParameter'"
                                                                   v-on:keypress="isNumber($event)" />
                                                            <span class="highlight"></span>
                                                            <label>End Column</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <span v-show="errors.has('bankRow')" class="text-danger">Hellot</span>
                                        </div>
                                        <div class="row col-sm-12">
                                            <div class="col-sm-9 col-md-7 dp-inline-fx">
                                                <div class="col-sm-6 pl-0">
                                                    <div class="mt-2 new-form">
                                                        <div class="floating-label d-flex flex-column flex-md-row">
                                                            <input v-model="rowstartvs"
                                                                   name="rowstartvs"
                                                                   title="Start row for TOTVS statement"
                                                                   aria-label="Start row value, use cursor up and down to increase or decrease"
                                                                   class="floating-input"
                                                                   type="number"
                                                                   placeholder=" "
                                                                   v-validate="'required|rowParameter'"
                                                                   v-on:keypress="isNumber($event)" />
                                                            <span class="highlight"></span>
                                                            <label>Start Row</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6 pr-0">
                                                    <div class="mt-2 new-form">
                                                        <div class="floating-label d-flex flex-column flex-md-row">
                                                            <input v-model="rowendvs"
                                                                   name="rowendvs"
                                                                   title="End row for TOTVS statement"
                                                                   aria-label="End row value, use cursor up and down to increase or decrease"
                                                                   class="floating-input"
                                                                   type="number"
                                                                   placeholder=" "
                                                                   v-validate="'required|rowParameter'"
                                                                   v-on:keypress="isNumber($event)" />
                                                            <span class="highlight"></span>
                                                            <label>End Row</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row col-sm-12">
                                            <div class="col-sm-9 col-md-7">
                                                <span v-show="errors.has('colstartvs'&&'colendvs'&&'rowstartvs'&&'rowendvs')"
                                                      class="text-danger">Please enter the mandatory parameters</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 p-0 m-0 row b-line mb-4 mt-3"></div>
                                    <div class="row col-sm-12">
                                        <div class="col">
                                            <button class="btn btn-primary mr-4"
                                                    title="Generate reconcilation button"
                                                    aria-label="Click Generate button to create reconcilation file"
                                                    v-on:click="generateReport"
                                                    :disabled="btnDisabled">
                                                Generate
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <br />
                                <div v-if="showreconciliationsuccess" class="col-sm-6 alert"
                                     style="margin-left:20px;word-wrap: break-word;box-shadow: 0 0 1rem 0 rgba(0,0,0,.2);">
                                    <font-awesome-icon :icon="['fas', 'check-circle']" class="icon check" style="width:16px;height:16px;color:#168736;" />
                                    &nbsp;&nbsp;Reconciliation Done Successfully
                                    <div style="padding-top: 10px;">
                                        <a :href="fileName"
                                           class="alert-link"
                                           style="cursor: pointer;color:#155cb4;">
                                            <font-awesome-icon :icon="['fas', 'download']" class="icon download" style="width:16px;height:16px;" />
                                            &nbsp;&nbsp;Click here to download
                                        </a>
                                    </div>
                                </div>
                                <!--<div v-if="loading">
                                    <img class="progressLoader" />
                                </div>-->
                                <div v-if="showreconciliationwarning" class="col-sm-6 alert"
                                     style="margin-left:20px;box-shadow:  0 0 1rem 0 rgba(0,0,0,.2);">
                                    <font-awesome-icon :icon="['fas', 'exclamation-circle']" class="icon exclamationCircle" style="width:16px;height:16px;color:#b9251c;" />
                                    &nbsp;&nbsp;Fail to process the request, Please check & verify below points:
                                    <ul>
                                        <li>Select client.</li>
                                        <li>Upload the files for the selected client.</li>
                                        <li>Data range provided is correct.</li>
                                        <li>Refer user manual for more help.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import Navbar from "../Navbar/Navbar";
    import CommonService from "../../services/SharedService/common.service.js";
    import ACRService from "../../services/ACRService/ACR.service.js";
    import AppValidations from "../../services/validation.js";
    import VeeValidate from "vee-validate";
    import { EnvironmentConfig } from '../../services/constants';
    import Algorithm from '../../services/Algorithm.js';
    export default {
        name: "ACRHome",
        data() {
            return {
                selectedBank: "",
                selectedClient: "",
                bankandclientmap: [],
                bankarrayresult: [],
                clientarrayresult: [],
                startdate: "",
                enddate: "",
                formatteddate: "",
                BankclientmappingID: "",
                BankUploadFile: "Choose file (Max file size 100 MB)",
                TOTVUploadFile: "Choose file (Max file size 100 MB)",
                finalfiles: new FormData(),
                bankStatementFile: "",
                filelist: {},
                bankname: "",
                clientname: "",
                rowstartbs: "",
                rowendbs: "",
                colstartbs: "",
                colendbs: "",
                rowstartvs: "2",
                rowendvs: "",
                colstartvs: "1",
                colendvs: "12",
                menu1: false,
                menu2: false,
                startdateFormatted: "",
                enddateFormatted: "",
                showreconciliationsuccess: false,
                showreconciliationwarning: false,
                fileName: "",
                loading: false,
                btnDisabled: false,
                isDateValid: true,
                fileSize: EnvironmentConfig._FileSize
            };
        },
        components: {
            Navigation: Navbar,
            VeeValidate
        },
        mixins: [CommonService, ACRService, AppValidations, Algorithm],
        created: function () {
            localStorage.setItem("route", this.$route.name);
            this.loadBankNames();
        },
        watch: {
            startdate() {
                if (this.startdate && this.enddate)
                    this.validateDate(this.startdate, this.enddate);
            },
            enddate() {
                if (this.startdate && this.enddate)
                    this.validateDate(this.startdate, this.enddate);
            }
        },
        methods: {
            loadBankNames() {
                this.BankClientMapping().then(response => {
                    if (response) {
                        this.bankandclientmap = response.data;
                        const map = new Map();
                        for (const item of this.bankandclientmap) {
                            if (!map.has(item.bankId)) {
                                map.set(item.bankId, true); // set any value to Map
                                this.bankarrayresult.push({
                                    bankId: item.bankId,
                                    bankname: item.bankname
                                });
                            }
                        }
                    }
                });
            },
            handleBankStatement() {
                this.bankStatementFile = this.$refs.bankStatementFile.files[0];
                this.BankUploadFile = this.bankStatementFile.name;
            },
            handleTOTVSStatement() {
                this.TOTVStatementFile = this.$refs.TOTVStatementFile.files[0];
                this.TOTVUploadFile = this.TOTVStatementFile.name;
            },
            handleclientMapping() {
                this.clientarrayresult = [];
                for (var i = 0; i < this.bankandclientmap.length; i++) {
                    if (this.bankandclientmap[i].bankname == this.selectedBank) {
                        this.clientarrayresult.push({
                            clientId: this.bankandclientmap[i].clientId,
                            clientname: this.bankandclientmap[i].clientname
                        });
                    }
                }
            },
            findMappingId() {
                for (var i = 0; i < this.bankandclientmap.length; i++) {
                    if (
                        this.bankandclientmap[i].bankname == this.selectedBank &&
                        this.bankandclientmap[i].clientname == this.selectedClient
                    ) {
                        return this.bankandclientmap[i].id;
                    }
                }
            },
            generateReport() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.bankclientmapId = this.findMappingId();
                        const formData = new FormData();
                        formData.append("Bankname", this.selectedBank);
                        formData.append("Clientname", this.selectedClient);
                        formData.append("ReconFromDate", this.startdate);
                        formData.append("ReconToDate", this.enddate);
                        formData.append("BankClientMapID", this.bankclientmapId);
                        formData.append("File", this.bankStatementFile);
                        formData.append("RowStartBS", this.rowstartbs);
                        formData.append("RowEndBS", this.rowendbs);
                        formData.append("ColumnStartBS", this.colstartbs);
                        formData.append("ColumnEndBS", this.colendbs);
                        formData.append("RowStartVS", this.rowstartvs);
                        formData.append("RowEndVS", this.rowendvs);
                        formData.append("ColumnStartVS", this.colstartvs);
                        formData.append("ColumnEndVS", this.colendvs);
                        formData.append("File", this.TOTVStatementFile);
                        formData.append("Username", localStorage.getItem("userName"));
                        formData.append("UserId", localStorage.getItem("userId"));
                        formData.append("FileType", localStorage.getItem("appName"));
                        this.loading = true;
                        this.ImportUploadedData(formData).then(Response => {
                            if (Response && !Response.isAxiosError) {
                                var reconciliationfile = Response.data;
                                if (
                                    reconciliationfile == "Internal server error" ||
                                    reconciliationfile == "500" ||
                                    reconciliationfile == "[object Object]"
                                ) {
                                    this.showreconciliationwarning = true;
                                    this.showreconciliationsuccess = false;
                                } else {
                                    this.fileName = reconciliationfile;
                                    this.showreconciliationwarning = false;
                                    this.showreconciliationsuccess = true;
                                }
                                this.loading = false;
                            } else {
                                this.loading = false;
                                this.showreconciliationwarning = true;
                                this.showreconciliationsuccess = false;
                            }
                        });
                    }
                });
            }
        }
    };
</script>
<style scoped>
    .homeText {
        font-size: 35px;
        color: red;
        text-align: center;
        position: relative;
        top: 30px;
        text-shadow: 2px 2px 2px gray;
    }

    span.remove-file {
        color: red;
        cursor: pointer;
        float: right;
    }

    select {
        /* styling */
        background-color: #e7e7ea;
        border: thin solid grey;
        border-radius: 4px;
        display: inline-block;
        font: inherit;
        line-height: 1.5em;
        padding: 0.5em 3.5em 0.5em 1em;
        /* reset */
        margin: 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-appearance: none;
        -moz-appearance: none;
        cursor: pointer;
    }

        select.selectarrow {
            background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);
            background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
            background-size: 5px 5px, 5px 5px, 1px 1.5em;
            background-repeat: no-repeat;
        }

            select.selectarrow:focus {
                background-image: linear-gradient(45deg, green 50%, transparent 50%), linear-gradient(135deg, transparent 50%, green 50%), linear-gradient(to right, #ccc, #ccc);
                background-position: calc(100% - 15px) 1em, calc(100% - 20px) 1em, calc(100% - 2.5em) 0.5em;
                background-size: 5px 5px, 5px 5px, 1px 1.5em;
                background-repeat: no-repeat;
                border-color: green;
                outline: 0;
            }

        select:-moz-focusring {
            color: transparent;
            text-shadow: 0 0 0 #000;
        }

    .appName {
        font-size: 1.5rem;
    }
    .subHeader {
        font-size: 1.25rem;
    }
</style>

